module.exports = __webpack_public_path__ + "static/cycling_plans-987e87ed4ebf85ab4de231b1277998bf.jpg";